export default __webpack_public_path__ + "static/media/Minicard_6h.90afaf3a.svg";